import React,{useState,useEffect} from "react";
import CustomHeading from '../../../constants/CustomHeading'
import {  Formik, Form} from 'formik';
import * as Yup from 'yup';
import CustomInput from '../../../constants/CustomInput';
import CustomTextArea from '../../../constants/CustomTextArea';
import CustomDropdown from '../../../constants/CustomDropdown';
import CustomButton from '../../../constants/CustomButton';
import CustomRichTextField from "../../../constants/CustomRichTextField";
import CustomTableWithAll from '../../../constants/CustomTableWithAll';
import {connect} from 'react-redux';
import {setworkshopattendedData,getworkshopattendedData} from '../../../redux/actions/dataAction';
import CustomLine from "../../../constants/CustomLine";


const validationSchema = Yup.object().shape({
    title: Yup.string()
    .required('Required'),
    select_level: Yup.string()
    .required('Required'),
    type: Yup.string()
    .required('Required'),
    your_role: Yup.string()
    .required('Required'),
    invited: Yup.string()
    .required('Required'),
    start_data:Yup.string()
    .required('Required'),
    end_data:Yup.string()
    .required('Required'),
 
});
const WorkshopAttended = (props) => {
    const [isLoading,setIsLoading]=useState(false);
    useEffect(()=>{
        props.getworkshopattendedData();
    },[isLoading])
    const columns = [ 
        {title:'Program Title',field:'title'},
        {title:'Your Role',field:'your_role' },
        {title:'Level',field:'select_level'},
        {title: "Event organizer",field:"event_organizer"},
        {title:'Start Date',field:'start_data'},
        {title:'End Date',field:'end_data'}
      ]
  return (
    <div className="customContainer">
        <CustomHeading title="Conference / Seminar / Training  / Development / Workshop Attended"/>
        <CustomTableWithAll data={props?.workshop_attended?.data}  columns={columns} api="/api/workshop_attended/"  title={'All Workshop'} />
        <CustomLine/>
        <Formik 
                initialValues={{
                    title:'',
                    type:'',
                    event_organizer:'',
                    venue:'',
                    select_level:'',
                    your_role:'',
                    invited:'',
                    other:'',
                    start_data:'',
                    end_data:'',
                    sponsored_by:'',
                    highlights:'',

                   }}
                   validationSchema={validationSchema}
                   onSubmit={values => {
                    console.log(values)
                    props.setworkshopattendedData(values);
                    setIsLoading(true)
                    
                  }}
            >
            {({ errors, touched,handleChange,handleSubmit }) => (
            <Form onSubmit={handleSubmit} style={{marginTop:0}}>
                <div className="row">
                    <div className="col-md-6">
                    <CustomInput
                        type={'text'}
                        placeholder={'Enter Program title '}
                        label={'Program title :'}
                        onChange={handleChange('title')}
                        errorText={
                            errors.title && touched.title ?errors.title :null
                        }
                        
                    />
                    </div>
                    <div className="col-md-6">
                    <CustomDropdown 
                    label="Type : "
                    data={[{value:"Workshop"},{value:"Training & Workshop"},{value:"Conference"},{value:"Training"},{value:"Seminar"},{value:"Development"}]}
                    onChange={handleChange('type')}
                    errorText={
                        errors.type && touched.type ?errors.type :null
                    }
                    />
                    </div>
                </div>


                <div className="row">
                    <div className="col-md-4">
                    <CustomDropdown 
                    label="Select level : "
                    data={[{value:"State"},{value:"National"},{value:"International"},{value:"Institute"}]}
                    onChange={handleChange('select_level')}
                    errorText={
                        errors.select_level && touched.select_level ?errors.select_level :null
                    }
                    />
                    </div>
                    <div className="col-md-4">
                    <CustomDropdown 
                    label="Your role : "
                    data={[{value:"Resource Person"},{value:"Participants"},{value:"Author"},{value:"Others"}]}
                    onChange={handleChange('your_role')}
                    errorText={
                        errors.your_role && touched.your_role ?errors.your_role :null
                    }
                    />
                    </div>
                    <div className="col-md-4">
                    <CustomDropdown 
                    label="Invited/Deputed : "
                    data={[{value:"Invited"},{value:"Deputed"}]}
                    onChange={handleChange('invited')}
                    errorText={
                        errors.invited && touched.invited ?errors.invited :null
                    }
                    />
                    </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                        <CustomInput
                            type={'text'}
                            label={'Event Organizer : '}
                            onChange={handleChange('event_organizer')}
                            errorText={
                                errors.event_organizer && touched.event_organizer ?errors.event_organizer :null
                            }
                            
                        />
                        </div>
                        <div className="col-md-6">
                        <CustomTextArea
                            type={'text'}
                            label={'venue : '}
                            rows={2}
                            placeholder={'Enter Venue'}
                            onChange={handleChange('venue')}
                        />	
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                        <CustomInput
                            type={'date'}
                            label={'Start date: '}
                            onChange={handleChange('start_data')}
                            errorText={
                                errors.start_data && touched.start_data ?errors.start_data :null
                            }
                            
                        />
                        </div>
                    <div className="col-md-6">
                        <CustomInput
                            type={'date'}
                            label={'End date : '}
                            onChange={handleChange('end_data')}
                            errorText={
                                errors.end_data && touched.end_data ?errors.end_data :null
                            }
                            
                        />
                    </div>
                </div>
                <div className="row mb-5">
                    <div className="col-md-6">
                        <CustomRichTextField label={'Highlights'} onChange={handleChange('highlights')}/>
                    </div>
                    <div className="col-md-2 my-3">
                    <CustomButton type="submit" label="Save" isIcon/>
                    </div>
                </div>
             </Form>
              )}
            </Formik>
    </div>
  );
};

const mapActionWithProps = {
    getworkshopattendedData,
    setworkshopattendedData,
  }
  
  const mapStateWithProps = (state)=>(
    {
        workshop_attended:state.data.workshop_attended
    }
  )
  export default connect(mapStateWithProps,mapActionWithProps)(WorkshopAttended);
